import { Checkbox } from '../../ui/checkbox';

const labelClass = 'block text-sm font-medium text-[#00163E] mb-1.5';
const errorClass = 'text-red-500 text-xs mt-1';

const URGENCIA_OPTIONS = [
  'Inmediata (esta semana)',
  'Corto plazo (este mes)',
  'Medio plazo (1-3 meses)',
  'Sin urgencia definida',
];

const DISPONIBILIDAD_OPTIONS = [
  'Mañanas',
  'Tardes',
  'Flexible',
  'Solo por email inicialmente',
];

export default function StepLogistica({ data, errors, onChange }) {
  return (
    <div className="space-y-6">
      {/* Urgencia */}
      <div>
        <label className={labelClass}>Urgencia del mandato</label>
        <p className="text-[#8A9BB1] text-xs mb-3">
          ¿Con qué urgencia necesita incorporar apoyo externo?
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {URGENCIA_OPTIONS.map((u) => {
            const selected = data.urgencia === u;
            return (
              <button
                key={u}
                type="button"
                onClick={() => onChange('urgencia', u)}
                data-testid={`field-urgencia-${u.split(' ')[0].toLowerCase()}`}
                className={`px-4 py-3 text-sm rounded border text-left transition-all duration-200 ${
                  selected
                    ? 'border-[#C58C40] bg-[#C58C40]/5 text-[#C58C40]'
                    : 'border-[#E4E6EA] text-[#00163E]/60 hover:border-[#00163E]/30'
                }`}
              >
                {u}
              </button>
            );
          })}
        </div>
        {errors.urgencia && <p className={errorClass}>{errors.urgencia}</p>}
      </div>

      {/* Disponibilidad */}
      <div>
        <label className={labelClass}>Disponibilidad para llamada de validación</label>
        <p className="text-[#8A9BB1] text-xs mb-3">
          ¿Cuándo podemos contactarle para validar su mandato?
        </p>
        <div className="grid grid-cols-2 gap-2">
          {DISPONIBILIDAD_OPTIONS.map((d) => {
            const selected = data.disponibilidad === d;
            return (
              <button
                key={d}
                type="button"
                onClick={() => onChange('disponibilidad', d)}
                data-testid={`field-disponibilidad-${d.split(' ')[0].toLowerCase()}`}
                className={`px-4 py-3 text-sm rounded border text-left transition-all duration-200 ${
                  selected
                    ? 'border-[#C58C40] bg-[#C58C40]/5 text-[#C58C40]'
                    : 'border-[#E4E6EA] text-[#00163E]/60 hover:border-[#00163E]/30'
                }`}
              >
                {d}
              </button>
            );
          })}
        </div>
        {errors.disponibilidad && <p className={errorClass}>{errors.disponibilidad}</p>}
      </div>

      {/* NDA Checkbox */}
      <div
        className={`p-6 rounded border transition-colors ${
          errors.aceptaNDA ? 'border-red-400 bg-red-50/50' : 'border-[#E4E6EA] bg-[#00163E]/[0.02]'
        }`}
      >
        <div className="flex gap-4">
          <Checkbox
            id="nda-checkbox"
            checked={data.aceptaNDA}
            onCheckedChange={(checked) => onChange('aceptaNDA', checked)}
            data-testid="field-nda-checkbox"
            className="mt-0.5 border-[#00163E]/30 data-[state=checked]:bg-[#C58C40] data-[state=checked]:border-[#C58C40]"
          />
          <label
            htmlFor="nda-checkbox"
            className="text-sm text-[#00163E]/80 leading-relaxed cursor-pointer"
          >
            Entiendo que la información compartida es estrictamente confidencial y que
            el proceso de emparejamiento se rige por los términos de Conadvy, incluyendo
            NDA y modelo de Success Fee.
          </label>
        </div>
        {errors.aceptaNDA && <p className={`${errorClass} mt-2 ml-8`}>{errors.aceptaNDA}</p>}
      </div>
    </div>
  );
}
